import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Skeleton from "react-loading-skeleton";

/**
 * @private
 *
 * @description
 * Default skeleton page to render while a Micro-Frontend is in a loading state.
 */
export const MicroFrontendSkeleton = () => {
  return (
    <Row spacingInset="400 none none 400" overflowY="hidden" data-testid="microfrontendskeleton-container-row">
      <Column width="99%" data-testid="microfrontendskeleton-skeleton-column">
        <Skeleton height="91vh" />
      </Column>
    </Row>
  );
};
